import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { useCopyValue } from '../../../hooks'
import { BUTTON_HEIGHT_24 } from '../../Button'
import { QA_NAME_GRETA_AI_CHAT_CHAT_MENU } from '../GretaAIChat.constants'
import { GretaAIChatRowMenu } from '../GretaAIChatRowMenu'

import { getGretaAIChatChatMenuItems } from './GretaAIChatChatMenu.utils'

function GretaAIChatChatMenu({
  buttonHeight = BUTTON_HEIGHT_24,
  chat,
  className,
  qaName = QA_NAME_GRETA_AI_CHAT_CHAT_MENU,
  onDelete = EMPTY_FUNCTION,
  onOpenChange = EMPTY_FUNCTION,
  onRename = EMPTY_FUNCTION,
}) {
  const { t } = useTranslation()

  const { handleCopy } = useCopyValue({
    errorNotificationKey: 'Greta.ChatIdCopyErrorKey',
    successNotificationKey: 'Greta.ChatIdCopiedKey',
    value: chat.id,
  })

  function handleRename() {
    onRename(chat)
  }

  function handleDelete() {
    onDelete(chat)
  }

  return (
    <GretaAIChatRowMenu
      buttonHeight={buttonHeight}
      className={className}
      items={getGretaAIChatChatMenuItems({
        t,
        onCopyId: handleCopy,
        onDelete: handleDelete,
        onRename: handleRename,
      })}
      qaName={qaName}
      onOpenChange={onOpenChange}
    />
  )
}

export default GretaAIChatChatMenu
